module.exports = __webpack_public_path__ + "static/img/12.3138859.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/eng/12.png
// module id = 0lIS
// module chunks = 0